import styled from "styled-components";

const Container = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: calc(100vw * (10 / 375));
    width: 100%;
    height: calc(100vw * (46 / 375));
    font-size: calc(100vw * (14 / 375));
    font-weight: bold;
    color: var(--gray01);
    background-color: var(--gray03);

    & .icon {
      width: calc(100vw * (26 / 375));
      height: calc(100vw * (26 / 375));
    }
  }
`;

export { Container };

export default { Container };
